export const getButtonStyles = (isDarkMode: boolean) => {
  return {
    backgroundColor: isDarkMode ? "#f0f0f0" : "#201b41",
    borderRadius: ".5rem",
    color: isDarkMode ? "#201b41" : "#f0f0f0",
    fontSize: "1.2rem",
    padding: ".5rem 1.5rem",
  };
};

export const getDeleteButtonStyles = (isDarkMode: boolean) => {
  return {
    backgroundColor: isDarkMode ? "#FF0000" : "#FF0000",
    borderRadius: ".5rem",
    color: isDarkMode ? "#f0f0f0" : "#f0f0f0",
    fontSize: "1.2rem",
    padding: ".5rem 1.5rem",
    minHeight: "2.2rem",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: "#cc0000",
    },
  };
};
